// extracted by mini-css-extract-plugin
module.exports = {"loading":"ActiveSpinner_loading__2Q92h","lds-ring":"ActiveSpinner_lds-ring__3VqZ5"};